import ROUTES from './routes';

const SIDEBAR_GROUPS = {
  apps: { name: 'apps', displayName: 'Apps' },
  drivers: { name: 'drivers', displayName: 'Drivers' },
  mappings: { name: 'mappings', displayName: 'Mappings' },
  services: { name: 'services', displayName: 'Services' },
  host: { name: 'host', displayName: 'Host' },
  rubixFlows: { name: 'RF', displayName: 'RubixFlows' },
  userManagement: { name: 'userManagement', displayName: 'Users' },
};

export const SIDEBAR_KEYS = {
  MASTER_SLAVES: 'masterSlaves',
  SERVICES: 'services',
  RUBIX_APPS: 'rubixApps',
  SLAVE_BIOS_APPS: 'slaveBiosApps',
  SERVICE_MAPPING: 'serviceMapping',
  MQTT: 'mqtt',
  API_CLIENT: 'apiClient',
  LOGGING: 'logging',
  IP_SCANNING: 'ipScanning',
  CLOUD_NETWORKS: 'cloudNetworks',
  MODBUS: 'modbus',
  BACNET_MASTER: 'bacnetMaster',
  BACNET_SERVER: 'bacnetServer',
  LORA: 'lora',
  FILE_MANAGER: 'fileManager',
  APP_MANAGER: 'appManager',
  USER_MANAGEMENT: 'userManagement',
  SCHEDULES: 'schedules',
  SYNC_LOGS: 'syncLogs',
  PLUGIN_DISTRO: 'pluginDistro',
  FLOW_NETWORK: 'flowNetwork',
  FLOW_NETWORK_CLONE: 'flowNetworkClone',
  FLOW_NETWORK_NDP: 'flowNetworkNDP',
  RUBIX_FLOW_ALL_NETWORK_DEVICES: 'rubixFlowAllNetworkDevices',
  RUBIX_FLOW_ALL_POINTS: 'rubixFlowAllPoints',
  RF_SCHEDULES: 'rfSchedules',
  PLUGINS: 'plugins',
  RUBIX_FLOW: 'rubixFlow',
};

export const sidebarItems = [
  {
    type: 'divider',
    group: SIDEBAR_GROUPS.apps,
    keys: [SIDEBAR_KEYS.MASTER_SLAVES, SIDEBAR_KEYS.SERVICES, SIDEBAR_KEYS.SLAVE_BIOS_APPS, SIDEBAR_KEYS.RUBIX_APPS],
  },
  {
    type: 'item',
    title: 'Master/Slaves',
    link: '/master-slaves',
    key: SIDEBAR_KEYS.MASTER_SLAVES,
    icon: 'mdi-account-child-outline',
  },
  {
    type: 'item',
    title: 'BIOS Apps',
    link: '/slaves-bios-apps',
    key: SIDEBAR_KEYS.SLAVE_BIOS_APPS,
    icon: 'mdi-graph-outline',
  },
  { type: 'item', title: 'Rubix Apps', link: '/rubix-apps', key: SIDEBAR_KEYS.RUBIX_APPS, icon: 'mdi-apps' },
  { type: 'item', title: 'Services', link: '/services', key: SIDEBAR_KEYS.SERVICES, icon: 'mdi-hammer-screwdriver' },
  // { title: 'Config > IO 10', link: '/io-10-config', key: 'io10Config', icon: 'mdi-chemical-weapon' },
  {
    type: 'divider',
    group: SIDEBAR_GROUPS.drivers,
    keys: [
      SIDEBAR_KEYS.CLOUD_NETWORKS,
      SIDEBAR_KEYS.MODBUS,
      SIDEBAR_KEYS.BACNET_MASTER,
      SIDEBAR_KEYS.BACNET_SERVER,
      SIDEBAR_KEYS.LORA,
    ],
  },
  { type: 'item', title: 'Rubix', link: '/rubix-driver', key: SIDEBAR_KEYS.CLOUD_NETWORKS, icon: 'mdi-cloud' },
  { type: 'item', title: 'Modbus Master', link: '/modbus', key: SIDEBAR_KEYS.MODBUS, icon: 'mdi-table' },
  {
    type: 'item',
    title: 'BACnet Master',
    link: '/bacnet-master',
    key: SIDEBAR_KEYS.BACNET_MASTER,
    icon: 'mdi-source-fork',
  },
  { type: 'item', title: 'BACnet Server', link: '/bacnet-server', key: SIDEBAR_KEYS.BACNET_SERVER, icon: 'mdi-server' },
  { type: 'item', title: 'LoRa Network', link: '/lora-network', key: SIDEBAR_KEYS.LORA, icon: 'mdi-motion-sensor' },
  { type: 'divider', group: SIDEBAR_GROUPS.mappings, keys: [SIDEBAR_KEYS.SERVICE_MAPPING] },
  {
    type: 'item',
    title: 'Point Mapping',
    link: '/service-mapping',
    key: SIDEBAR_KEYS.SERVICE_MAPPING,
    icon: 'mdi-map',
  },
  {
    type: 'divider',
    group: SIDEBAR_GROUPS.services,
    keys: [
      SIDEBAR_KEYS.SCHEDULES,
      SIDEBAR_KEYS.SYNC_LOGS,
      SIDEBAR_KEYS.MQTT,
      SIDEBAR_KEYS.API_CLIENT,
      SIDEBAR_KEYS.LOGGING,
      SIDEBAR_KEYS.IP_SCANNING,
    ],
  },
  {
    type: 'item',
    title: 'Schedules',
    link: '/schedules',
    key: SIDEBAR_KEYS.SCHEDULES,
    icon: 'mdi-calendar-plus',
  },
  {
    title: 'Sync Logs',
    type: 'item',
    link: ROUTES.syncLogs,
    key: SIDEBAR_KEYS.SYNC_LOGS,
    icon: 'mdi-android-messages',
    dependentKey: SIDEBAR_KEYS.RUBIX_FLOW,
  },
  { type: 'item', title: 'MQTT', link: '/mqtt', key: SIDEBAR_KEYS.MQTT, icon: 'mdi-protocol' },
  { type: 'item', title: 'REST', link: '/api-client', key: SIDEBAR_KEYS.API_CLIENT, icon: 'mdi-api' },
  { type: 'item', title: 'Logging', link: '/logging', key: SIDEBAR_KEYS.LOGGING, icon: 'mdi-history' },
  { type: 'item', title: 'Ip Scan', link: '/ip-scanning', key: SIDEBAR_KEYS.IP_SCANNING, icon: 'mdi-magnify-scan' },
  {
    type: 'divider',
    group: SIDEBAR_GROUPS.rubixFlows,
    dependentKey: SIDEBAR_KEYS.RUBIX_FLOW,
    keys: [
      SIDEBAR_KEYS.PLUGINS,
      SIDEBAR_KEYS.FLOW_NETWORK,
      SIDEBAR_KEYS.FLOW_NETWORK_CLONE,
      SIDEBAR_KEYS.FLOW_NETWORK_NDP,
      SIDEBAR_KEYS.RUBIX_FLOW_ALL_NETWORK_DEVICES,
      SIDEBAR_KEYS.RUBIX_FLOW_ALL_POINTS,
      SIDEBAR_KEYS.RF_SCHEDULES,
    ],
  },
  {
    title: 'Plugins',
    type: 'item',
    link: '/plugins',
    key: SIDEBAR_KEYS.PLUGINS,
    icon: 'mdi-puzzle',
    dependentKey: SIDEBAR_KEYS.RUBIX_FLOW,
  },
  {
    title: 'Rubix Flow Network',
    type: 'item',
    link: ROUTES.rfFlowNetworkRoot,
    key: SIDEBAR_KEYS.FLOW_NETWORK,
    icon: 'mdi-view-stream',
    dependentKey: SIDEBAR_KEYS.RUBIX_FLOW,
  },
  {
    title: 'Rubix Flow Network Clone',
    type: 'item',
    link: ROUTES.rfFlowNetworkCloneRoot,
    key: SIDEBAR_KEYS.FLOW_NETWORK_CLONE,
    icon: 'mdi-view-stream',
    dependentKey: SIDEBAR_KEYS.RUBIX_FLOW,
  },
  {
    title: 'Networks',
    type: 'item',
    link: ROUTES.rfNetworkDevicePoint,
    key: SIDEBAR_KEYS.FLOW_NETWORK_NDP,
    icon: 'mdi-server-network',
    dependentKey: SIDEBAR_KEYS.RUBIX_FLOW,
  },
  {
    title: 'All Network Devices',
    type: 'item',
    link: ROUTES.rfAllNetworkDevices,
    key: SIDEBAR_KEYS.RUBIX_FLOW_ALL_NETWORK_DEVICES,
    icon: 'mdi-application',
    dependentKey: SIDEBAR_KEYS.RUBIX_FLOW,
  },
  {
    title: 'All Points',
    type: 'item',
    link: ROUTES.rfAllPoints,
    key: SIDEBAR_KEYS.RUBIX_FLOW_ALL_POINTS,
    icon: 'mdi-application',
    dependentKey: SIDEBAR_KEYS.RUBIX_FLOW,
  },
  {
    title: 'RF Schedules',
    type: 'item',
    link: ROUTES.rfSchedules,
    key: SIDEBAR_KEYS.RF_SCHEDULES,
    icon: 'mdi-calendar',
    dependentKey: SIDEBAR_KEYS.RUBIX_FLOW,
  },
  { type: 'divider', group: SIDEBAR_GROUPS.userManagement, keys: [SIDEBAR_KEYS.USER_MANAGEMENT] },
  {
    type: 'item',
    title: 'User Management',
    link: '/user-management',
    key: SIDEBAR_KEYS.USER_MANAGEMENT,
    icon: 'mdi-account',
  },
  { type: 'divider', group: SIDEBAR_GROUPS.host, keys: [SIDEBAR_KEYS.FILE_MANAGER, SIDEBAR_KEYS.APP_MANAGER] },
  { type: 'item', title: 'File Manager', link: '/file', key: SIDEBAR_KEYS.FILE_MANAGER, icon: 'mdi-file' },
  {
    type: 'item',
    title: 'Backup/Restore',
    link: '/app-manager',
    key: SIDEBAR_KEYS.APP_MANAGER,
    icon: 'mdi-backup-restore',
  },
];

export const serviceItems = [
  { id: 'BACNET_SERVER', name: 'rubix-bacnet-server', fileName: 'nubeio-bacnet-server.service' },
  { id: 'LORA_RAW', name: 'lora-raw', fileName: 'nubeio-lora-raw.service' },
  { id: 'POINT_SERVER', name: 'rubix-point-server', fileName: 'nubeio-point-server.service' },
  { id: 'RUBIX_PLAT', name: 'rubix-plat-build', fileName: 'rubix' },
  { id: 'WIRES', name: 'wires-builds', fileName: 'nubeio-rubix-wires.service' },
];

export const units = [
  'metersPerSecondPerSecond',
  'squareMeters',
  'squareCentimeters',
  'squareFeet',
  'squareInches',
  'currency1',
  'currency2',
  'currency3',
  'currency4',
  'currency5',
  'currency6',
  'currency7',
  'currency8',
  'currency9',
  'currency10',
  'milliamperes',
  'amperes',
  'amperesPerMeter',
  'amperesPerSquareMeter',
  'ampereSquareMeters',
  'decibels',
  'decibelsMillivolt',
  'decibelsVolt',
  'farads',
  'henrys',
  'ohms',
  'ohmMeters',
  'ohmMeterPerSquareMeter',
  'milliohms',
  'kilohms',
  'megohms',
  'microSiemens',
  'millisiemens',
  'siemens',
  'siemensPerMeter',
  'teslas',
  'volts',
  'millivolts',
  'kilovolts',
  'megavolts',
  'voltAmperes',
  'kilovoltAmperes',
  'megavoltAmperes',
  'ampereSeconds',
  'ampereSquareHours',
  'voltAmpereHours',
  'kilovoltAmpereHours',
  'megavoltAmpereHours',
  'voltAmperesReactive',
  'kilovoltAmperesReactive',
  'megavoltAmperesReactive',
  'voltAmpereHoursReactive',
  'kilovoltAmpereHoursReactive',
  'megavoltAmpereHoursReactive',
  'voltsPerDegreeKelvin',
  'voltsPerMeter',
  'voltsSquareHours',
  'degreesPhase',
  'powerFactor',
  'webers',
  'joules',
  'kilojoules',
  'kilojoulesPerKilogram',
  'megajoules',
  'joulesPerHours',
  'wattHours',
  'kilowattHours',
  'megawattHours',
  'wattHoursReactive',
  'kilowattHoursReactive',
  'megawattHoursReactive',
  'btus',
  'kiloBtus',
  'megaBtus',
  'therms',
  'tonHours',
  'joulesPerKilogramDryAir',
  'kilojoulesPerKilogramDryAir',
  'megajoulesPerKilogramDryAir',
  'btusPerPoundDryAir',
  'btusPerPound',
  'joulesPerDegreeKelvin',
  'kilojoulesPerDegreeKelvin',
  'megajoulesPerDegreeKelvin',
  'joulesPerKilogramDegreeKelvin',
  'newton',
  'cyclesPerHour',
  'cyclesPerMinute',
  'hertz',
  'kilohertz',
  'megahertz',
  'perHour',
  'gramsOfWaterPerKilogramDryAir',
  'percentRelativeHumidity',
  'micrometers',
  'millimeters',
  'centimeters',
  'kilometers',
  'meters',
  'inches',
  'feet',
  'candelas',
  'candelasPerSquareMeter',
  'wattsPerSquareFoot',
  'wattsPerSquareMeter',
  'lumens',
  'luxes',
  'footCandles',
  'milligrams',
  'grams',
  'kilograms',
  'poundsMass',
  'tons',
  'gramsPerSecond',
  'gramsPerMinute',
  'kilogramsPerSecond',
  'kilogramsPerMinute',
  'kilogramsPerHour',
  'poundsMassPerSecond',
  'poundsMassPerMinute',
  'poundsMassPerHour',
  'tonsPerHour',
  'milliwatts',
  'watts',
  'kilowatts',
  'megawatts',
  'btusPerHour',
  'kiloBtusPerHour',
  'horsepower',
  'tonsRefrigeration',
  'pascals',
  'hectopascals',
  'kilopascals',
  'pascalSeconds',
  'millibars',
  'bars',
  'poundsForcePerSquareInch',
  'millimetersOfWater',
  'centimetersOfWater',
  'inchesOfWater',
  'millimetersOfMercury',
  'centimetersOfMercury',
  'inchesOfMercury',
  'degreesCelsius',
  'degreesKelvin',
  'degreesKelvinPerHour',
  'degreesKelvinPerMinute',
  'degreesFahrenheit',
  'degreeDaysCelsius',
  'degreeDaysFahrenheit',
  'deltaDegreesFahrenheit',
  'deltaDegreesKelvin',
  'years',
  'months',
  'weeks',
  'days',
  'hours',
  'minutes',
  'seconds',
  'hundredthsSeconds',
  'milliseconds',
  'newtonMeters',
  'millimetersPerSecond',
  'millimetersPerMinute',
  'metersPerSecond',
  'metersPerMinute',
  'metersPerHour',
  'kilometersPerHour',
  'feetPerSecond',
  'feetPerMinute',
  'milesPerHour',
  'cubicFeet',
  'cubicFeetPerDay',
  'cubicMeters',
  'cubicMetersPerDay',
  'imperialGallons',
  'milliliters',
  'liters',
  'usGallons',
  'cubicFeetPerSecond',
  'cubicFeetPerMinute',
  'cubicFeetPerHour',
  'cubicMetersPerSecond',
  'cubicMetersPerMinute',
  'cubicMetersPerHour',
  'imperialGallonsPerMinute',
  'millilitersPerSecond',
  'litersPerSecond',
  'litersPerMinute',
  'litersPerHour',
  'usGallonsPerMinute',
  'usGallonsPerHour',
  'degreesAngular',
  'degreesCelsiusPerHour',
  'degreesCelsiusPerMinute',
  'degreesFahrenheitPerHour',
  'degreesFahrenheitPerMinute',
  'jouleSeconds',
  'kilogramsPerCubicMeter',
  'kilowattHoursPerSquareMeter',
  'kilowattHoursPerSquareFoot',
  'megajoulesPerSquareMeter',
  'megajoulesPerSquareFoot',
  'noUnits',
  'newtonSeconds',
  'newtonsPerMeter',
  'partsPerMillion',
  'partsPerBillion',
  'percent',
  'percentObscurationPerFoot',
  'percentObscurationPerMeter',
  'percentPerSecond',
  'perMinute',
  'perSecond',
  'psiPerDegreeFahrenheit',
  'radians',
  'radiansPerSecond',
  'revolutionsPerMinute',
  'squareMetersPerNewton',
  'wattsPerMeterPerDegreeKelvin',
  'wattsPerSquareMeterDegreeKelvin',
  'perMille',
  'gramsPerGram',
  'kilogramsPerKilogram',
  'gramsPerKilogram',
  'milligramsPerGram',
  'milligramsPerKilogram',
  'gramsPerMilliliter',
  'gramsPerLiter',
  'milligramsPerLiter',
  'microgramsPerLiter',
  'gramsPerCubicMeter',
  'milligramsPerCubicMeter',
  'microgramsPerCubicMeter',
  'nanogramsPerCubicMeter',
  'gramsPerCubicCentimeter',
  'wattHoursPerCubicMeter',
  'joulesPerCubicMeter',
  'becquerels',
  'kilobecquerels',
  'megabecquerels',
  'gray',
  'milligray',
  'microgray',
  'sieverts',
  'millisieverts',
  'microsieverts',
  'microsievertsPerHour',
  'decibelsA',
  'nephelometricTurbidityUnit',
  'pH',
  'gramsPerSquareMeter',
  'minutesPerDegreeKelvin',
];

export const START_APP = 'start';
export const RESTART_APP = 'restart';
export const STOP_APP = 'stop';
export const REFRESH_APP = 'refresh';
export const ENABLE_APP = 'enable';
export const DISABLE_APP = 'disable';
export const CRON_APP = 'cron';

export const RUBIX_APP_STATUS_CONTROL_ACTIONS = {
  STOP: STOP_APP,
  START: START_APP,
  RESTART: RESTART_APP,
  REFRESH: REFRESH_APP,
  ENABLE: ENABLE_APP,
  DISABLE: DISABLE_APP,
  CRON: CRON_APP,
};

export const RUBIX_APP_TYPES = {
  INSTALLER: 'Installer',
  FRONTEND_APP: 'FrontendApp',
  PYTHON_APP: 'PythonApp',
  APT_APP: 'AptApp',
  OTHERS: 'Others',
};

export const ENV_CONFIG_TYPE = '.env';
export const JSON_CONFIG_TYPE = '.json';
export const OPENVPN_CONFIG_TYPE = '.openvpn';

export const APP_CONFIG_TYPES = {
  [RUBIX_APP_TYPES.FRONTEND_APP]: ENV_CONFIG_TYPE,
  [RUBIX_APP_TYPES.PYTHON_APP]: JSON_CONFIG_TYPE,
  [RUBIX_APP_TYPES.APT_APP]: OPENVPN_CONFIG_TYPE,
};

export const ALWAYS_RUNNING_RUBIX_APP = {
  RUBIX_PLAT: 'RUBIX_PLAT',
};

export const SERVICE_NAMES = {
  RUBIX_BIOS: 'rubixBios',
  RUBIX_SERVICE: 'rubixService',
  RUBIX_FLOW_FRAMEWORK: 'FLOW_FRAMEWORK',
};
export const MODBUS_RTU_PORTS = ["/dev/ttyRS485-1", "/dev/ttyRS485-2", "/dev/ttyXBEE-1 ", "/dev/ttyXBEE-2", "/dev/ttyUSB0", "/dev/ttyUSB1", "/dev/ttyUSB2", "/dev/ttyUSB3", "/dev/ttyUSB4", "/data/socat/loRa1", "/data/socat/gpio1"];

export const APP_DOWNLOAD_STATUSES = {
  DOWNLOAD_IN_PROGRESS: 'DOWNLOAD_IN_PROGRESS',
  DOWNLOAD_COMPLETE: 'DOWNLOAD_COMPLETE',
};

export const DATA_TABLE_PROPS = {
  FOOTER_PROPS: {
    showFirstLastPage: true,
    firstIcon: 'mdi-chevron-double-left',
    lastIcon: 'mdi-chevron-double-right',
    prevIcon: 'mdi-chevron-left',
    nextIcon: 'mdi-chevron-right',
    itemsPerPageOptions: [10, 25, 50, -1],
  },
  ITEMS_PER_PAGE: 50,
};

export const USER_VERIFICATION_STATE = {
  VERIFIED: 'VERIFIED',
  UNVERIFIED: 'UNVERIFIED',
};

export const MAPPING_STATE = {
  MAPPED: 'MAPPED',
  BROKEN: 'BROKEN',
};
